import React from "react";
import { useState, useEffect } from "react";
import {
  Menu,
  X,
  ShoppingCart,
  Search,
  ChevronDown,
  ChevronRight,
  User,
  Heart,
  Globe,
} from "lucide-react";
import { useNavigate } from "react-router-dom";
import { usePanier } from "./PanierContext";
import SearchBar from "./SearchBar";
import axios from "axios";
// Couleurs du drapeau du Niger
const COLORS = {
  orange: "#E87E04",
  white: "#FFFFFF",
  green: "#008751",
  darkGreen: "#006B3F",
  lightOrange: "#FFE0B2",
  lightGreen: "#CCFFCC",
  gray: "#718096",
  lightGray: "#E2E8F0",
  paleGreen: "#E6FFEA",
};
function HomeHeader2() {
  const [mobileMenuOpen, setMobileMenuOpen] = useState(false);
  const { panier } = usePanier();
  const navigate = useNavigate();
  const [likedProducts, setLikedProducts] = useState(new Set());

  const BackendUrl = process.env.REACT_APP_Backend_Url;

  const userId = JSON.parse(localStorage.getItem("userEcomme"))?.id;

  useEffect(() => {
    if (userId) {
      fetchUserLikes();
    }
  }, [userId]);

  const fetchUserLikes = async () => {
    try {
      const response = await axios.get(`${BackendUrl}/likes/user/${userId}`);
      const likedIds = new Set(response.data?.map((like) => like.produit?._id));
      setLikedProducts(likedIds);
      // console.log(likedIds.size);
    } catch (error) {
      console.error("Erreur lors du chargement des likes:", error);
    }
  };

  return (
    <div style={{ zIndex: "1000" }}>
      {" "}
      {/* Header */}
      <header className="bg-white shadow-md">
        {/* Top Bar */}
        <div className="bg-green-700" style={{ backgroundColor: COLORS.green }}>
          <div className="container mx-auto px-4 py-2 flex justify-between items-center text-white">
            <div className="text-sm">
              <span className="hidden md:inline">
                Livraison gratuite à partir de 100€ |{" "}
              </span>
              {/* <span>Support: +32 465 96 54 36</span> */}
            </div>
            <div className="flex items-center space-x-4">
              <div className="text-sm flex items-center">
                <span className="mr-1">EUR</span>
                <ChevronDown size={16} />
              </div>

            </div>
          </div>
        </div>

        {/* Main Header */}
        <div className="container mx-auto px-4 py-4">
          <div className="flex items-center justify-between">
            {/* Logo */}
            <div
              className="font-bold text-2xl text-green-700"
              style={{ color: COLORS.green }}
              onClick={() => navigate(`/`)}
            >
              KASSARMOU
            </div>

            {/* Search on desktop */}
            <div className="hidden md:flex flex-1 max-w-md mx-8">
              <SearchBar />
            </div>

            {/* Navigation for desktop */}
            <nav className="hidden md:flex items-center space-x-8">
              <a
                onClick={() => navigate(`/Compte`)}
                className="flex items-center hover:text-green-700 transition-colors"
              >
                <User size={20} className="mr-1" />
                <span>Compte</span>
              </a>
              <a
                onClick={() => navigate(`/Like produit`)}
                className="flex items-center hover:text-green-700 transition-colors"
              >
                <Heart size={20} className="mr-1" />
                <span>Favoris ( {likedProducts?.size} )</span>
              </a>
              <a
                onClick={() => navigate(`/panier`)}
                className="flex items-center text-orange-500"
                style={{ color: COLORS.orange }}
              >
                <ShoppingCart size={20} className="mr-1" />
                <span>Panier ( {panier.length} )</span>
              </a>
            </nav>

            {/* Mobile menu button */}
            <div className="md:hidden flex items-center">
              <button
                onClick={() => setMobileMenuOpen(!mobileMenuOpen)}
                className="text-gray-700 focus:outline-none"
              >
                {mobileMenuOpen ? <X size={24} /> : <Menu size={24} />}
              </button>
            </div>
          </div>

          {/* Search on mobile */}
          <div className="mt-4 md:hidden">
            <SearchBar />
          </div>

          {/* Mobile menu */}
          {mobileMenuOpen && (
            <div className="mt-4 md:hidden pb-4 border-b">
              <nav className="flex flex-col space-y-4">
                <a
                  onClick={() => navigate(`/Compte`)}
                  className="flex items-center hover:text-green-700 transition-colors"
                >
                  <User size={20} className="mr-2" />
                  <span>Compte</span>
                </a>
                <a
                  onClick={() => navigate(`/Like produit`)}
                  className="flex items-center hover:text-green-700 transition-colors"
                >
                  <Heart size={20} className="mr-2" />
                  <span>Favoris ( {likedProducts?.size} )</span>
                </a>
                <a
                  onClick={() => navigate(`/panier`)}
                  className="flex items-center text-orange-500"
                  style={{ color: COLORS.orange }}
                >
                  <ShoppingCart size={20} className="mr-2" />
                  <span>Panier ( {panier.length} )</span>
                </a>
              </nav>
            </div>
          )}
        </div>

        {/* Categories nav */}
        <div className="border-t border-b bg-gray-50">
          <div className="container mx-auto px-4 py-3 overflow-x-auto">
            <div className="flex space-x-8 whitespace-nowrap">
              <a
                onClick={() => navigate(`/`)}
                className="font-medium text-gray-700 hover:text-green-700 transition-colors"
              >
                Accueil
              </a>
              <a
                onClick={() => navigate(`/produits`)}
                className="font-medium text-gray-700 hover:text-green-700 transition-colors"
              >
                Produits
              </a>
              <a
                onClick={() => navigate(`/AboutNigerPage`)}
                className="font-medium text-gray-700 hover:text-green-700 transition-colors"
              >
                À propos du Niger
              </a>
              <a
                onClick={() => navigate(`/NotreEngagementPage`)}
                className="font-medium text-gray-700 hover:text-green-700 transition-colors"
              >
                Notre engagement
              </a>
              <a
                onClick={() => navigate(`/Commande`)}
                className="font-medium text-gray-700 hover:text-green-700 transition-colors"
              >
                Commandes
              </a>
              <a
                onClick={() => navigate(`/ContactPage`)}
                className="font-medium text-gray-700 hover:text-green-700 transition-colors"
              >
                Contact
              </a>
            </div>
          </div>
        </div>
      </header>
    </div>
  );
}

export default HomeHeader2;
